<!-- блок операций для сообщения в тикете -->
<template>
	<!-- враппер -->
	<div v-if="id"
		:class="{ 'w5-opers-button-opened': show, 'pull-left-ticket-message-opers-button': toLeft, 'pull-right': !toLeft }"
		class="btn-group w5-opers-button"
		style="top: -2px"
		@click.stop="toggleMenu"
		:data-index="id">
		<!-- сама кнопка -->
		<span class="dropdown-toggle">
			<font-awesome-icon icon="bars" /> <span class="caret"></span>
		</span>
		<!-- пункты меню -->
		<ul v-show="show" class="dropdown-menu" role="menu" @click.stop :style="cssUl">

			<li v-if="isUpdateButtonVisible" @click.stop="clickOper('update')">
				<font-awesome-layers class="w5-dropdown-menu-item w5-opers-button-other-btn">
					<font-awesome-icon icon="pencil-alt" class="color-green" />
					{{ 'main/redact' | ftc }}
				</font-awesome-layers>
			</li>

			<!-- разделитель -->
			<li v-if="isUpdateButtonVisible && (isQuoteButtonVisible || isViewButtonVisible || isDeleteButtonVisible)" class="divider"></li>

			<li v-if="isQuoteButtonVisible" @click.stop="clickOper('quote')">
				<font-awesome-layers class="w5-dropdown-menu-item w5-opers-button-other-btn">
					<font-awesome-icon icon="quote-right" style="color: #2c8ad8" />
					{{ 'main/quote' | ftc }}
				</font-awesome-layers>
			</li>

			<li v-if="isViewButtonVisible" @click.stop="clickOper('view')">
				<font-awesome-layers class="w5-dropdown-menu-item w5-opers-button-other-btn">
					<font-awesome-icon icon="eye" style="color: #2c8ad8" />
					{{ 'main/view' | ftc }}
				</font-awesome-layers>
			</li>

			<!-- разделитель -->
			<li v-if="(isUpdateButtonVisible || isQuoteButtonVisible || isViewButtonVisible) && isDeleteButtonVisible" class="divider"></li>

			<li v-if="isDeleteButtonVisible" @click.stop="clickOper('delete')">
				<font-awesome-layers class="w5-dropdown-menu-item w5-opers-button-other-btn">
					<font-awesome-icon icon="trash-alt" style="color: red" />
					{{ 'ticketrule/action_delete' | ftc }}
				</font-awesome-layers>
			</li>
			
		</ul>
	</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import $ from 'jquery'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'ticketMessageOpersButtonComponent',
	//=========================================================================
	// данные - пункты меню
	//=========================================================================
	props: ['message', 'status', 'toLeft'],
	//=========================================================================
	// локальные переменные
	//=========================================================================
	data() {
		return {
			// показывать/скрывать все меню
			show: false,
			// сообщение - заводим ее, так как она может меняться родителем
			Message: null,
			// стиль блока
			cssUl: false
		}
	},
	//=========================================================================
	// кмопонент создан
	//=========================================================================
	created() {
		this.Message = this.message
	},
	//=========================================================================
	//  вычисляемые неизменяемые переменные
	//=========================================================================
	computed: {
		id() {
			return this.Message && this.Message['message_id'] ? this.Message['message_id'] : false
		},

		isUpdateButtonVisible() {
			return this.status !== 'closed' && this.status !== 'deleted' && this.isAccess('ticketmessage/update')
		},

		isQuoteButtonVisible() {
			return this.Message && this.Message['message_content']
		},

		isViewButtonVisible() {
			return this.isAccess('ticketmessage/view')
		},

		isDeleteButtonVisible() {
			return this.status !== 'closed' && this.status !== 'deleted' && this.isAccess('ticketmessage/delete')
		}
	},
	//=========================================================================
	// после того как компонент смонтирован
	//=========================================================================
	mounted() {
		$(document).on('keydown.ticketmessagedropdownmenu.' + this.id, this.KeyDownHandler)
		$(document).on('toggleDropDownTicketMessageOperMenu.' + this.id, this.handleToggle)
		$(document).on('click.ticketmessagedropdownmenu.' + this.id, this.ClickOnDocument)
	},
	//=========================================================================
	// перед уничтожением компонента
	//=========================================================================
	beforeDestroy() {
		$(document).off('keydown.ticketmessagedropdownmenu.' + this.id, this.KeyDownHandler)
		$(document).off('toggleDropDownTicketMessageOperMenu.' + this.id, this.handleToggle)
		$(document).off('click.ticketmessagedropdownmenu.' + this.id, this.ClickOnDocument)
	},
	//=========================================================================
	// локальные методы компонента
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// показывает/скрывает меню
		//---------------------------------------------------------------------
		toggleMenu(e) {
			// информируем другие блоки - мы кликнули по кнопке
			$(document).trigger('toggleDropDownTicketMessageOperMenu', [this.id])
			// меняем видимость на противоположную
			this.show = !this.show
			// рассчитаем - куда открывать
			this.UpOrDown()
		},
		//---------------------------------------------------------------------
		// обработчик события - закрывают или открывают какое то такое же меню
		//---------------------------------------------------------------------
		handleToggle(e, idx) {
			// если не наше - то наше нужно просто закрыть
			if (idx !== this.id) this.hideMenu()
		},
		//---------------------------------------------------------------------
		// скрывает меню
		//---------------------------------------------------------------------
		hideMenu() {
			this.show = false
		},
		//---------------------------------------------------------------------
		// кликнули по пункту меню
		//---------------------------------------------------------------------
		clickOper(action) {
			this.hideMenu()
			this.$emit('action', {
				'action': action,
				'id': this.id,
				'message': this.Message
			})
		},
		//---------------------------------------------------------------------
		// обработчик нажатий клавиш
		//---------------------------------------------------------------------
		KeyDownHandler(e) {
			if (this.show && e.keyCode === 27) this.hideMenu()
		},
		//---------------------------------------------------------------------
		// обработчик клика по документу
		//---------------------------------------------------------------------
		ClickOnDocument(e) {
			if (this.show) this.hideMenu()
		},
		//---------------------------------------------------------------------
		// куда открывать - вверх или вниз
		//---------------------------------------------------------------------
		UpOrDown() {
			// стиль по умолчанию
			this.cssUl = this.toLeft ? 'right: auto !important; left: 0;' : false

			// находим главный блок
			let _div = $('div[data-index="' + this.id + '"]')
			if (!_div.length) return

			// в нем находим блок с меню
			let _ul = _div.find('ul:first')
			if (!_ul.length) return

			// находим расположение главного блока и высоты
			let _rect = _div.offset()
			let _heightDiv = _div.height()
			let _heightUl = _ul.height()

			// расчитаем координаты низ блока с меню
			let _bottomUl = _rect.top + _heightDiv + _heightUl + 20 - $(window).scrollTop()
			// если они ниже высоты окна
			if (_bottomUl > window.innerHeight)
				if (this.cssUl) this.cssUl += 'top: -' + (_heightDiv + _heightUl) + 'px'
				else this.cssUl = 'top: -' + (_heightDiv + _heightUl) + 'px'
		}

		//---------------------------------------------------------------------
	},
	//=========================================================================
	// наблюдатель
	//=========================================================================
	watch: {
		'message': function(message) {
			this.Message = message
		}
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style>
.pull-left-ticket-message-opers-button {
	float: left !important;
    margin-left: 7px;
}
</style>




// WEBPACK FOOTER //
// ticketmsgopers.vue?2f65d60c